module.exports = __webpack_public_path__ + "img/audiolibro.78747e96.jpg";